import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import AutoQuery from 'servicestack/auto-query/auto-query'
import $session from 'servicestack/session'
import cartConfig from "emun.cart/cart.config";
import customerConfig from "emun.customer/customer.config";

class DealerPromptController {
    constructor($rootScope, $uibModalInstance, options) {
        var $ctrl = this;
        basicController($ctrl);
		var model = $ctrl.model = options.model;
		var bus = $ctrl.bus = new ServiceBus($rootScope);
		$ctrl.$uibModalInstance = $uibModalInstance;
		$ctrl.config = cartConfig;
		$ctrl.customerConfig = customerConfig;
		if (!$ctrl.model.dealer) {
			var date = new Date();
			$ctrl.model.dealer = {
				tags: {}
			};
			$ctrl.new = true;
		} else {
			$ctrl.new = false;
		}

        $ctrl.title = options.title || 'Dealer...';
		$ctrl.locations = new AutoQuery({
			url: "QueryRetailerShippingLocations.json?Status=Active",
			orderBy: "City,Name",
			critiera: {
				StatusNotEqualTo: "Inactive"
			},
			autoLoad: false,
			pageSize: 1000,
			onLoaded: args => $ctrl.locationsLoaded(args)
		});
		$ctrl.save = $ctrl.submit = function () {
			if ($ctrl.model.dealer.id && !$ctrl.new) {
				bus.send('UpdateDealerLocation.json', $ctrl.model.dealer).then(function (response) {
					$rootScope.$emit('dealerSaved', $ctrl.model);
					$uibModalInstance.close($ctrl.model);
				});
			} else {
				bus.send('CreateDealerLocation.json', $ctrl.model.dealer).then(function (response) {
					$rootScope.$emit('dealerSaved', $ctrl.model);
					$uibModalInstance.close($ctrl.model);
				});
			}
		};
        $ctrl.delete = function () {
            $uibModalInstance.close($ctrl.model);
            return modals.confirm("Are you sure?", "Delete Dealer Location").result.then(function () {
                $ctrl.bus.send('DeleteDealerLocation.json', $ctrl.model.dealer).then(function (response) {
                    $rootScope.$emit('dealerDeleted', $ctrl);
                });
            });
        };
	}
	$onInit() {
		const $ctrl = this;
		if ($ctrl.model.dealer.retailerId) {
			return $ctrl.bus
				.send(`QueryRetailersSearch.json?Id=${$ctrl.model.dealer.retailerId}`)
				.then(
					({
						data: {
							results: [retailer]
						}
					}) => {
						if (retailer) {
							$ctrl.selectRetailer(retailer);
						} else {
							console.warn("retailer not found", $ctrl.model.dealer.retailerId);
						}
					}
				);
		}
	}
	findRetailers(val) {
		const $ctrl = this;
		var search = encodeURIComponent(val);
		let url = `QueryRetailersSearch.json?Take=5&Status=Active&Search=${search}&OrderBy=CompanyName`; //
		return $ctrl.bus
			.send(url)
			.then(res =>
				res.data.results.map(retailer =>
					Object.assign(retailer, { config: cartConfig })
				)
			);
	}

	selectRetailer(val) {
		const $ctrl = this;
		var retailerChanged = false;
		if ($ctrl.model.dealer.retailerId !== val.id) retailerChanged = true;
		if (retailerChanged) {
			$ctrl.model.dealer.shippingLocationId = "";
		}

		$ctrl.model.dealer.retailer = val;
		$ctrl.model.dealer.retailerId = val.id;
		$ctrl.locations.filter("RetailerId", $ctrl.model.dealer.retailerId);
	}

	locationsLoaded(args) {
		let $ctrl = this;
		var argsCount = args.results.length;
		const matches = args.results.filter(
			sl => sl.id === $ctrl.model.dealer.shippingLocationId
		);
		if (matches.length > 0) {
			$ctrl.model.dealer.shippingLocation = matches[0];
		} else if (argsCount === 1) {
			$ctrl.model.dealer.shippingLocation = args.first;
			$ctrl.model.dealer.shippingLocationId = (args.first || {}).id;
		}
	}

	changeShippingLocation() {
		let $ctrl = this;
		const location = $ctrl.locations.results.filter(
			r => r.id === $ctrl.model.dealer.shippingLocationId
		)[0];
	}

	dismiss(reason) {
		let $ctrl = this;
		$ctrl.$uibModalInstance.dismiss(reason);
	}
}

export default DealerPromptController;